import { Box, Typography, useTheme } from '@mui/material';
import Title2 from '../../../components/title/title2';
import CustomBreadCrumb from '../../../components/breadcrumb/custom-breadcrumb';
import { useTranslation } from 'react-i18next';

const BlogDetailsHero = ({
    id,
    title,
    description,
    intro
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <CustomBreadCrumb
                list={[
                    {label: t('company'), link: "/"},
                    {label: t('navigation.blog'), link: "/blog"}
                ]}
                activeSection={id}
            />

            <Title2 
                title={title}
                description={description}
            />

            <Box
                sx={{
                    pb: {xs: 2, md: 5}
                }}
            >
                <img 
                    src={intro.image}
                    alt="Banner" 
                    width='100%'
                    style={{
                        borderRadius: 32
                    }}
                />
            </Box>

            {
                intro.content.map((item, index) => {
                    return <Typography
                        key={index}
                        fontWeight={500}
                        fontSize={{xs: 12, lg: 14}}
                        textAlign="justify"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                        sx={{
                            py: 1
                        }}
                    >
                        {item}
                    </Typography>
                })
            }
        </>
    );
}

export default BlogDetailsHero;